export default "__VITE_ASSET__BJ3YNlUL__"